import { createSelector } from '@ngrx/store';
import { DiningOption } from '../../../models';
import { AppState } from '../app.state';

export const selectDiningOptions = createSelector(
  (state: AppState) => state.diningOptions,
  (diningOptions: DiningOption[]) => diningOptions
);
